import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BaseConfigurableComponent } from '@app/base-config.component';

@Component({
  selector: 'afcu-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  imports: [RouterLink]

})
export class FooterComponent extends BaseConfigurableComponent{

  constructor() {
    super('footer')
  }
}

